import React, { Component } from 'react';
import { connect } from 'react-redux';

import { saveDisplayAnnotationColorChange } from 'PipeRouter';
import CSS from './styles.scss';
import {  CaretDown as CDIcon } from 'Shared/Icons';


const Fragment = React.Fragment;
const keys = {
  tab:    9,
  enter:  13,
  esc:    27,
  space:  32,
  left:   37,
  up:     38,
  right:  39,
  down:   40,
  shift:  16
};

//what to display?
class FilterByMenu extends Component {
  onDisplayAnnotationColorChange = event => {
    const { displayAnnotationColors, saveDisplayAnnotationColorChange } = this.props;
    const { id, checked } = event.target || event;

    const updateDisplayColors = displayAnnotationColors.map(color =>
      color.markerId === id && !color.disabled
        ? { ...color, display: checked }
        : color
    );

    saveDisplayAnnotationColorChange(updateDisplayColors);
  };

  openMenu = event => {
    const button = event.currentTarget.querySelector('button');
    
    const isExpanded = button.getAttribute('aria-expanded');
    
    if (button.textContent.includes('Highlight Color') || button.tagName === 'polygon') {
      const expandedStatusChanged = isExpanded !== 'true'
      
      button.setAttribute('aria-expanded', expandedStatusChanged);
      const menu = event.currentTarget.querySelector('ul');
      const toDisplay = expandedStatusChanged? "display: block;" : "display: none;";
      menu.setAttribute('style', toDisplay);
      
      const listItems = menu.querySelectorAll('li');
      listItems[0].focus();

      event.preventDefault();
      event.stopPropagation();
    }
  };

  renderMenu = () => {
    const { displayAnnotationColors } = this.props;

    return (
      <div className={ CSS['menu-container'] }>
        <ul className={ CSS['submenu'] }>
          <li role="menuitem" tabIndex="-1" className={ CSS['text'] } onKeyDown={ this.onMenuItemKeyDown }>red</li>
          <li role="menuitem" tabIndex="-1" className={ CSS['text'] } onKeyDown={ this.onMenuItemKeyDown }>green</li>
          <li role="menuitem" tabIndex="-1" className={ CSS['text'] } onKeyDown={ this.onMenuItemKeyDown }>blue</li>
          <li role="menuitem" tabIndex="-1" className={ CSS['text'] } onKeyDown={ this.onMenuItemKeyDown }>yellow</li>
          {
            displayAnnotationColors.map(el => {
              const { color, display, disabled, label, markerId } = el;
              return (
                <li key={ markerId } className={ CSS['list-item'] }>
                  <label className={ CSS['label-old'] } htmlFor={ markerId }></label>
                  <input type="checkbox" id={ markerId } checked={ display } disabled={ disabled } onChange={ this.onDisplayAnnotationColorChange }/>
                  <svg className={ CSS['svg-circle'] } width="20" height="20" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" fill={ color } />
                  </svg>
                  <span className={ CSS['label-text-old'] }>{ label }</span>
                </li>
              );
            })
          }
        </ul>
      </div>
    );
  };

  onMenuItemKeyDown = event => {
    const { currentParentIndex, goToNextMenuFromSubmenu } = this.props;
    const { keyCode, target } = event;
    const { nextElementSibling, previousElementSibling, parentNode } = target;
    const menuItems = parentNode.children;
    const firstMenuItem = menuItems[0];
    const miLen = menuItems.length;
    const lastMenuItem = menuItems[miLen - 1];
    const menu = target.parentElement;

    if (keyCode === keys.tab) {
      if (event.shiftKey) {
        const parent = target.parentElement.parentElement.querySelector('button');
        const parent2 = target.parentElement.parentElement;
        parent.setAttribute('aria-expanded', false);
        const menu = target.parentElement;
        menu.setAttribute('style', "display: none;");
        goToNextMenuFromSubmenu(parent2, currentParentIndex - 1);
        parent.focus();
        event.preventDefault();
        event.stopPropagation();
      } else {
        const parent = target.parentElement.parentElement.querySelector('button');
        const parent2 = target.parentElement.parentElement;
        parent.setAttribute('aria-expanded', false);
        const menu = target.parentElement;
        menu.setAttribute('style', "display: none;");
        goToNextMenuFromSubmenu(parent2, currentParentIndex + 1);
        parent.focus();
        event.preventDefault();
        event.stopPropagation();
      }
    }

    if (keyCode === keys.esc) {
      const parent = target.parentElement.parentElement.querySelector('button');
      const parent2 = target.parentElement.parentElement;
      
      parent.setAttribute('aria-expanded', false);
      menu.setAttribute('style', "display: none;");
      parent.focus();
    }

    if (keyCode === keys.down) {
      if (nextElementSibling) {
        nextElementSibling.focus();
        const id = nextElementSibling.getAttribute("id")
        menu.setAttribute('aria-activedescendant', id);
        event.preventDefault();
        event.stopPropagation();
      } else {        
        firstMenuItem.focus();
        const id = firstMenuItem.getAttribute("id")
        menu.setAttribute('aria-activedescendant', id);
        event.preventDefault();
        event.stopPropagation();
      }
    }

    if (keyCode === keys.up) {
      if (previousElementSibling) {
        previousElementSibling.focus();
        const id = previousElementSibling.getAttribute("id")
        menu.setAttribute('aria-activedescendant', id);
        event.preventDefault();
        event.stopPropagation()
        return false;
      } else {
        lastMenuItem.focus();
        const id = lastMenuItem.getAttribute("id")
        menu.setAttribute('aria-activedescendant', id);
        event.preventDefault();
        event.stopPropagation()
        return false;
      }
    }

    if (keyCode === keys.right) {
      const parent = target.parentElement.parentElement;
      parent.setAttribute('aria-expanded', false);
      goToNextMenuFromSubmenu(parent, currentParentIndex + 1);
      event.preventDefault();
      event.stopPropagation();
    }
    if (keyCode === keys.left) {
      const parent = target.parentElement.parentElement;
      parent.setAttribute('aria-expanded', false);
      goToNextMenuFromSubmenu(parent, currentParentIndex - 1);
      event.preventDefault();
      event.stopPropagation();
    }

    if (keyCode === keys.enter || keyCode === keys.space) {
      const input = event.target.querySelector('input')
      input.checked = !input.checked;
      this.onDisplayAnnotationColorChange(input);
      event.preventDefault();
      event.stopPropagation();
    }
  };

  onMenuKeyDown = event => {
    const { currentParentIndex, goToNextMenu, goToNextMenuFromSubmenu, updateParentIndex } = this.props;
    let { keyCode, target } = event;
    const menus = target.parentElement.getElementsByClassName('menu');
    const mLen = menus.length;
    target = target.parentElement;

    if (keyCode === keys.up) {
      const menu = target.querySelector('ul');
      const button = target.querySelector('button');

      if (menu.children.length > 0) {
        const listItems = menu.querySelectorAll('li');
        button.setAttribute('aria-expanded', true);
        listItems[listItems.length-1].focus();
        menu.setAttribute('aria-activedescendant', listItems.length-1);
      }
    }

    if (keyCode === keys.down || keyCode === keys.space || keyCode === keys.enter) {
      const menu = target.querySelector('ul');
      const button = target.querySelector('button');

      if (menu.children.length > 0) {
        const listItems = menu.querySelectorAll('li');
        button.setAttribute('aria-expanded', true);
        menu.setAttribute('aria-activedescendant', 0)
        menu.setAttribute('style', "display: block;");
        listItems[0].focus();
      }
    }

    if (keyCode === keys.tab) {
      if (event.shiftKey) {
        if (currentParentIndex - 1 <= 0) {
          updateParentIndex(0);
        } else {
          goToNextMenu(target, currentParentIndex - 1);
          event.preventDefault();
        }
      } else {
        if (currentParentIndex === mLen-1) {
          updateParentIndex(mLen-1);
        } else {
          goToNextMenu(target, currentParentIndex + 1);
          // event.preventDefault();
        }
      }
    }

    if (keyCode === keys.right) {
      if (currentParentIndex === mLen-1) {
        goToNextMenu(target, 0);
        event.preventDefault();
      } else {
        goToNextMenu(target, currentParentIndex + 1);
        event.preventDefault();
      }
    }

    if (keyCode === keys.left) {
      if (currentParentIndex === 0) {
        goToNextMenu(target, mLen - 1);
        event.preventDefault();
      } else {
        goToNextMenu(target, currentParentIndex - 1);
        event.preventDefault();
      }
    }
  };

  render() {
    const { displayAnnotationColors } = this.props;

    return (
      <Fragment>
        <span className={ CSS['filter_title'] }>Filter by:</span>
        <li id="filterBy" data-test-id="filter-by-menu" className={`menu ${CSS['menu']}`}  
          onKeyDown={ this.onMenuKeyDown } 
          onClick={ this.openMenu }
        >
          <button type="button" data-test-id="filter-by-button" className={ CSS['filter_subTitle'] }  aria-label="Filter By Highlight Color" aria-haspopup="true" aria-controls="menusID" aria-expanded={false} >Highlight Color <CDIcon width="8px" height="6px" viewBox="0 0 8 6" fill="#00758e"  /></button>
          <ul role="menu" className={ CSS['submenu'] } id="menusID" aria-labelledby="menusID" tabIndex="-1" style={{display: 'none'}} >
            {
              displayAnnotationColors.map((el, i) => {
                const { color, display, disabled, label, markerId } = el;
                const colorName = { '#80e1fd': 'blue', '#a1ec80': 'green', '#f4ed75': 'yellow', '#ff7979': 'red' }[color] || label.toLowerCase();

                return (
                  <li id={i} key={ markerId } data-test-id={`filter-by-${label.toLowerCase()}`} className={ CSS['list-item'] } role="menuitem" tabIndex="-1" onClick={ e => e.stopPropagation() } onKeyDown={ this.onMenuItemKeyDown } aria-label={display?`${label} - Selected`:disabled?`${label} - Not Available`:`${label} - Not Selected`}>
                    <label className={ CSS['filter_checkBox'] } htmlFor={ markerId }></label>
                    <input type="checkbox" data-test-id={`${colorName}-checkbox`} id={ markerId } checked={ display } disabled={ disabled } onKeyDown={ this.onMenuItemKeyDown } onChange={ this.onDisplayAnnotationColorChange }/>
                    <svg className={ CSS['svg_circle'] } width="20" height="20" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" fill={ color } />
                    </svg>
                    <span className={ CSS['filter_label'] } aria-hidden={true}>{ label }</span>
                  </li>
                );
              })
            }
          </ul>
        </li>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { notebook:{ displayAnnotationColors }} = state;
  return { displayAnnotationColors };
}


export default connect(mapStateToProps, {
  saveDisplayAnnotationColorChange
})(FilterByMenu);
